// Vendor
import PropTypes from 'prop-types';
import { useState } from 'react';

// Components
import { Checkbox } from 'src/components/atoms/Checkbox';
import { DropdownButton } from 'src/components/atoms/DropdownButton';
import OutsideDetector from 'src/components/molecules/OutsideDetector/OutsideDetector';
import { Container, Option, OptionList } from './styles';

// Enums
import { PropertyStatus } from 'src/ts/enums';

const OPTIONS = [
  { value: PropertyStatus.ACTIVE, label: 'Active' },
  { value: PropertyStatus.DISABLED, label: 'Disabled' }
];

export type PropertyStatusFilterProps = {
  selected: PropertyStatus[];
  onChange: (statuses: PropertyStatus[]) => void;
  isDisabled?: boolean;
};

const PropertyStatusFilter: React.FC<PropertyStatusFilterProps> = ({
  selected,
  onChange,
  isDisabled
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = (status: PropertyStatus) => {
    // Rebuild from OPTIONS to keep a stable order.
    onChange(
      OPTIONS.map(({ value }) => value).filter((value) =>
        value === status ? !selected.includes(value) : selected.includes(value)
      )
    );
  };

  const summary =
    selected.length === 0
      ? 'All'
      : OPTIONS.filter(({ value }) => selected.includes(value))
          .map(({ label }) => label)
          .join(', ');

  return (
    <OutsideDetector onClickOutside={() => setIsOpen(false)}>
      <Container>
        <DropdownButton
          showLabel
          name="PropertyStatusFilter"
          label="Status"
          isOpen={isOpen}
          isDisabled={isDisabled}
          size="md"
          onOpened={() => setIsOpen(false)}
          onClosed={() => setIsOpen(true)}
        >
          {summary}
        </DropdownButton>

        {isOpen && !isDisabled && (
          <OptionList role="group" aria-label="Status">
            {OPTIONS.map(({ value, label }) => (
              <Option key={value}>
                <Checkbox
                  showLabel
                  name={`PropertyStatusFilter__${value}`}
                  value={value}
                  label={label}
                  isChecked={selected.includes(value)}
                  onClick={() => toggle(value)}
                />
              </Option>
            ))}
          </OptionList>
        )}
      </Container>
    </OutsideDetector>
  );
};

PropertyStatusFilter.propTypes = {
  selected: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
};

export default PropertyStatusFilter;
